<template>
    <div class="row prospectus-list" v-if="prospectuses.length !== 0">
        <div class="col-sm-12 table-responsive">
            <h2>{{conf.translations.searchresults}}</h2>
            <table id="prospectus-table" class="table" aria-live="polite">
                <thead>
                    <tr>
                        <th>{{conf.translations.corporation}}</th>
                        <th>{{conf.translations.approvalDate}}</th>
                        <th>{{conf.translations.typeOfProspectus}}</th>
                        <th v-if="lastSearchParams.ProspectusType===4">{{conf.translations.notificationDate}}</th>
                        <th v-if="lastSearchParams.ProspectusType===null">{{conf.translations.nationalIdentifier}}/{{conf.translations.notificationDate}}</th>
                        <th v-if="lastSearchParams.ProspectusType!==4 && lastSearchParams.ProspectusType!==null">{{conf.translations.nationalIdentifier}}</th>
                        
                        <!--<th v-if="prospectusTypesWithListing.includes(lastSearchParams.ProspectusType) || !lastSearchParams.ProspectusType">{{conf.translations.listing}}</th>-->
                    </tr>
                </thead>
                <prospectus-item v-for="(item, index) in prospectuses" :key="index" :prospectus="item" />
            </table>
        </div>
    </div>
    <div v-else-if="lastSearchParams !== null" class="row prospectus-list-no-data">
        <div id="prospectus-no-results" class="col-12-sm" role="alert">{{conf.translations.noresults}}</div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import axios from "axios";
    import ProspectusItem from './ProspectusItem.vue';

    export default {
        components: {
            ProspectusItem
        },
        computed: {
            ...mapState(["prospectuses", "conf", "lastSearchParams", "prospectusTypesWithListing"])
        }
    };
</script>